import {
	fullscreenLinkedList,
	setFullScreenValues
} from "~/solidJs/entities/FullScreenViewerEntity/models/fullScreenModel";
import { setCanvasStore } from "~/solidJs/entities/MagicBrushCanvas";
import { helperCreateObjectUrl } from "~/solidJs/shared/helpers";
import { SidebarModes, toggleSidebarWidget } from "~/solidJs/shared/helpers/toggleSidebarWidget";
import { initSvgViewerHoverMenu } from "~/solidJs/widgets/HoverFeatureMenu";
import Viewer from "../viewer";

export default class SvgViewer extends Viewer {
	static type = "image_svg";
	static supportedExtensions = ["svg"];
	constructor(asset, socketOutput = null, socketName = null) {
		super(asset, socketOutput, socketName);
		this.initSizeDom();
		this.dom.viewer.addEventListener("click", () => this.showFullscreenWithThisImage());
		if (socketName && socketOutput) {
			this.hoverCleanUp = initSvgViewerHoverMenu(this, socketOutput, socketName);
		}
	}
	initSizeDom() {
		const parent = this.dom.viewerContainer;
		this.dom.sizeContainer = document.createElement("div");
		this.dom.sizeContainer.className =
			"text-2xs flex absolute left-0 bottom-0 gap-2 flex-col rounded-md p-1 bg-white";
		parent.append(this.dom.sizeContainer);
	}

	changeFullScreenPreviewSrcByIndex() {
		this.fullScreenNode.value.asset = this.asset;
	}

	remove() {
		const newNode = fullscreenLinkedList.deleteNode(this.fullScreenNode);
		setFullScreenValues({
			activeItem: newNode
		});
	}

	loadAsync() {
		const url = helperCreateObjectUrl(this.asset);
		this.url = url;
		this.dom.image = document.createElement("img");
		this.dom.image.onload = () => {
			this.changeImageTextSize(this.dom.image.naturalHeight, this.dom.image.naturalWidth);
		};
		this.dom.image.classList.add("imageViewer");
		this.dom.image.src = url;
		this.domElement().append(this.dom.image);
		this.initFullScreenImage();
	}

	initFullScreenImage() {
		this.fullScreenInited = true;
		this.fullScreenNode = fullscreenLinkedList.createUnShiftNode({
			nodeUuid: this.socketsOutput.node.uuid,
			asset: this.asset
		});
	}

	async getAssetUrl() {
		return this.url;
	}

	addImageToCanvas = async () => {
		const asset = await this.getAsset();
		setCanvasStore({
			url: await this.getAssetUrl(),
			name: asset.name.split(".")[0],
			fromNodeId: this.socketsOutput.node.uuid,
			fromNodeSocketName: this.socketName,
			mode: "inpainting"
		});
		toggleSidebarWidget(SidebarModes.Inpaint);
	};
	changeImageTextSize(height, width) {
		this.dom.sizeContainer.textContent = `size ${width} x ${height}`;
	}
	reloadAssetAsync(asset) {
		this.asset = asset;
		const url = helperCreateObjectUrl(this.asset);
		this.url = url;
		this.dom.image.onload = () => {
			this.changeImageTextSize(this.dom.image.naturalHeight, this.dom.image.naturalWidth);
		};
		this.dom.image.src = url;
		this.changeFullScreenPreviewSrcByIndex();
		fullscreenLinkedList.unshiftNode(this.fullScreenNode);
	}
}
